import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { LogSearchCriteria } from './models/LogSearchCriteria';
import { LogDto } from './models/LogDto';

class LogsService {
    public getList(criteria: LogSearchCriteria) {
        return Http.get<Paged<LogDto>>('log', criteria);
    }

    public async log (data: any): Promise<void> {
        try {
            await Http.post('logger', data);
        } catch {
            // Never throw or re-log a logging failure: that would risk an infinite logging loop.
        }
    }
}

export default new LogsService();
